module.exports = __webpack_public_path__ + "static/img/closeMask_03.cfbf100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/closeMask_03.png
// module id = yp+m
// module chunks = 3